export default __webpack_public_path__ + "static/media/Aura-Egg__30.836c9fc3.png";